<template>
      <core-layout-content medium>
            <core-layout-headline-and-actions>
                  <template slot="headline">{{ $t("create_organization") }}</template>
            </core-layout-headline-and-actions>

            <!-- Body -->
            <j-card class="xs-12 bg5 r2 p4">
                  <create-update-form @input="handleSubmit">
                        <div class="flex xs-12 xs-between mt6" slot="actions" slot-scope="{ onSubmit }">
                              <j-button
                                    :isLoading="isLoading"
                                    @click="onSubmit"
                              >{{ $t("create_organization") }}</j-button>
                              <j-button
                                    type="bordered"
                                    @click="$router.push({ name: 'OrganizationsList' })"
                              >{{ $t("cancel") }}</j-button>
                        </div>
                  </create-update-form>
            </j-card>
      </core-layout-content>
</template>

<script>
import CoreFormInput from "@/modules/core/components/CoreFormInput"
import JCard from "@/components/JCard/"
import JButton from "@/components/JButton/"
import CoreLayoutContent from "@/modules/core/components/CoreLayoutContent.vue"
import CoreLayoutHeadlineAndActions from "@/modules/core/components/CoreLayoutHeadlineAndActions.vue"
import CreateUpdateForm from "../components/CreateUpdateForm"
import api from "../api/"

export default {
	components: {
		CoreFormInput,
		JCard,
		JButton,
		CoreLayoutContent,
		CoreLayoutHeadlineAndActions,
		CreateUpdateForm
	},

	data: () => ({
		isLoading: false
	}),

	methods: {
		async handleSubmit(payload) {
			this.isLoading = true

			const res = await api.createOrganization({
				createOrganizationInput: {
					nameFormat: payload.name,
					isActive: payload.isActive,
					photoPath: payload.photoPath,
					source: payload.source
				}
			})
			this.isLoading = false

			if (res.errors) {
				this.$store.dispatch("showError", res.errors)
				return
			}

			// Redirect to product detail of created product
			this.$router.push({
				name: "OrganizationsList"
			})
		}
	}
}
</script>
